import { Dialog, styled } from "../../../../../ui-component/mui.components"

export const BootstrapDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    width: "90vw",
    height: "95vh",
    maxWidth: "1265px",
    maxHeight: "957px",
    overflow: "hidden",
    padding: "32px",
    borderRadius: "16px",
    backgroundColor: "#F5F5F5"
  },
  "& .MuiDialogTitle-root": {
    padding: 0,
    display: "flex",
    alignItems: "flex-start",
  },
  "& .MuiDialogContent-root": {
    padding: 0,
    letterSpacing: "-0.5px",
    fontWeight: "normal",
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",

  },
}))
